import { atom } from "jotai";
import type { UnconfirmedCharges } from "@models/billing";

// Admin unconfirmed-charge worklist (#377/#382). null until the first
// successful fetch so the page can tell "not loaded yet" from "empty".
export const unconfirmedChargesAtom = atom<UnconfirmedCharges | null>(null);

export const isFetchingUnconfirmedChargesAtom = atom<boolean>(false);

// True while a clear (void/release) POST is in flight.
export const isClearingUnconfirmedChargeAtom = atom<boolean>(false);
